export default __webpack_public_path__ + "static/hero-cool-gadgets-8c8d7b4842b25972a104852b6dbee38a.jpg";